(function ($) {

  const ajaxUrl =
    window.ajaxurl ||
    document.body.dataset.ajaxurl ||
    '/wp-admin/admin-ajax.php';

  function getPayload($ajax, $block) {
    let payload = {};
    try { payload = JSON.parse($ajax.attr('data-payload') || '{}'); } catch (e) {}

    $block.find('[data-filter]').each(function () {
      payload[$(this).data('filter')] = $(this).val();
    });

    return payload;
  }

  function applyMasonry($wrap) {
    if (CSS.supports('grid-template-rows', 'masonry')) {
      $wrap.css({ gridTemplateRows: 'masonry' });
      return;
    }

    // Fallback JS masonry
    const colHeights = [];
    const cols = getComputedStyle($wrap[0]).gridTemplateColumns.split(' ').length;

    $wrap.children().each(function (i) {
      const col = i % cols;
      colHeights[col] = (colHeights[col] || 0) + this.offsetHeight;
      $(this).css('grid-row-end', `span ${Math.ceil(this.offsetHeight / 10)}`);
    });
  }

  function ajaxLoad($block, page, replace = false) {

    const $ajax = $block.find('[data-t-ajax="1"]');
    if (!$ajax.length) return;

    const payload = getPayload($ajax, $block);
    const nonce = $ajax.data('nonce');

    $block.addClass('is-loading');

    $.post(ajaxUrl, {
      action: 'testimonials_load_more',
      nonce,
      page,
      payload: JSON.stringify(payload)
    }).done(res => {

      if (!res.success) return;

      const $target = $block.find('.t-target');

      if (replace) $target.empty();
      $target.append(res.data.html);

      $ajax.attr('data-page', res.data.page);
      $ajax.attr('data-total', res.data.total_pages);

      if (!res.data.has_more) {
        $ajax.find('.t-ajax__btn').prop('disabled', true);
        $ajax.find('.t-ajax__sentinel').remove();
      }

      if ($block.hasClass('is-masonry')) {
        applyMasonry($target);
      }

    }).always(() => {
      $block.removeClass('is-loading');
    });
  }

  function bindPagination($block) {
    $block.on('click', '.pagination a[data-page]', function (e) {
      e.preventDefault();
      ajaxLoad($block, $(this).data('page'), true);
      history.pushState(null, '', $(this).attr('href'));
    });
  }

  function initInfinite($block) {
    const $sentinel = $block.find('.t-ajax__sentinel');
    if (!$sentinel.length) return;

    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting || $block.hasClass('is-loading')) return;
        const $ajax = $block.find('[data-t-ajax="1"]');
        ajaxLoad($block, parseInt($ajax.attr('data-page')) + 1);
      });
    });

    io.observe($sentinel[0]);
  }

  $(function () {
    $('[data-testimonials="1"]').each(function () {
      const $block = $(this);

      bindPagination($block);
      initInfinite($block);

      if ($block.hasClass('is-masonry')) {
        applyMasonry($block.find('.t-target'));
      }
    });
  });

})(jQuery);
